module.exports = __webpack_public_path__ + "img/08_WebFlow_13-1.ba9f52eb.svg";